import { render } from "./CategoryTreeNode.vue?vue&type=template&id=c94e1af2&scoped=true"
import script from "./CategoryTreeNode.vue?vue&type=script&lang=js"
export * from "./CategoryTreeNode.vue?vue&type=script&lang=js"

import "./CategoryTreeNode.vue?vue&type=style&index=0&id=c94e1af2&scoped=true&lang=css"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c94e1af2"]])

export default __exports__